(function () {
  function initialize() {
    var roots = document.querySelectorAll('[data-absen-marketing-popup]');

    Array.prototype.forEach.call(roots, function (root) {
      var dialog = root.querySelector('[data-popup-dialog]');
      if (!dialog || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';

      var enabled = root.dataset.enabled === 'true';
      var success = root.dataset.success === 'true';
      var hasError = root.dataset.error === 'true';
      var designMode = root.dataset.designMode === 'true';
      var openButton = document.querySelector('[aria-controls="' + root.id + '"]');
      var lastActiveElement = null;

      function anotherDialogIsOpen() {
        return document.querySelector('dialog[open]') !== null || Array.prototype.some.call(
          document.querySelectorAll('[data-absen-marketing-popup]:not([hidden])'),
          function (openPopup) { return openPopup !== root; }
        );
      }

      function show(event) {
        if ((!enabled && !success && !hasError && !designMode) || !root.hidden || anotherDialogIsOpen()) return;

        lastActiveElement = event && event.currentTarget === openButton ? openButton : document.activeElement;
        var media = root.querySelector('[data-popup-media]');
        if (media) media.replaceWith(media.content);
        root.hidden = false;
        if (openButton) openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('absen-marketing-popup-open');

        window.requestAnimationFrame(function () {
          var firstControl = dialog.querySelector('button, input, a[href], [tabindex]:not([tabindex="-1"])');
          (firstControl || dialog).focus();
        });
      }

      function closePopup() {
        if (root.hidden) return;

        root.hidden = true;
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('absen-marketing-popup-open');

        if (lastActiveElement && document.contains(lastActiveElement)) lastActiveElement.focus();
      }

      if (openButton) openButton.addEventListener('click', show);

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-popup-close]')) closePopup();
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup();
          return;
        }

        if (event.key !== 'Tab') return;

        var controls = dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
        if (!controls.length) return;

        var firstControl = controls[0];
        var lastControl = controls[controls.length - 1];

        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      });

      if (designMode) {
        document.addEventListener('shopify:section:select', function (event) {
          var section = root.closest('[id^="shopify-section-"]');
          var sectionId = section && section.id.replace('shopify-section-', '');
          if (event.detail && event.detail.sectionId === sectionId) show();
        });
      }

      if (success || hasError) show();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
